import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { useSystemStore } from '@/stores/systemStore';

let appInsights: ApplicationInsights | null = null;
/** Initializes telemetry from the system store; an empty connection string disables telemetry. */
export function initAppInsights() {
  if (appInsights) {
    return;
  }

  const store = useSystemStore();

  if (!store.appInsightConnectionString) {
    return;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString: store.appInsightConnectionString,
      enableCorsCorrelation: true,
    },
  });

  appInsights.addTelemetryInitializer((item: ITelemetryItem): boolean | void => {
    item.data = item.data || {};
    Object.assign(item.data, {
      appVersion: store.version,
      environment: store.environmentName,
      applicationName: 'PTW100-frontend',
      viewportDimensions: `${window.innerWidth}x${window.innerHeight}`,
    });

    return true;
  });

  appInsights.loadAppInsights();
}

export enum Level {
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

type ErrorProperties = {
  detail: string;
} & Record<string, string>;

// convenience function
export function trackException(
  error: Error,
  properties: ErrorProperties,
  level = Level.Info,
  flush = false,
) {
  if (!appInsights?.appInsights.isInitialized) {
    return;
  }

  appInsights.trackException({
    exception: error,
    properties: {
      level,
      errorName: error.name,
      errorType: error.constructor.name,
      ...properties,
    },
  });
  if (flush) {
    appInsights.flush();
  }
}

function errorLoggingTestFunction(arg: string) {
  trackException(
    new Error(arg),
    {
      detail: 'AppInsights logging error test',
    },
    Level.Info,
    true,
  );
}
(window as any).errorLoggingTestFunction = errorLoggingTestFunction;
